import { useContext } from "react";
import FactoryContext from "../../contexts/factoryContext";
import useQueryLeague from "../queries/useQueryLeague";

/**
 *
 * @returns {{leagueQuery: UseQueryResult<*, unknown>, league: ?League}}
 */
export default function useLeague() {
  let factory = useContext(FactoryContext);
  const leagueQuery = useQueryLeague();

  let league = null;
  if (leagueQuery?.data?.league) {
    league = factory.makeLeague(leagueQuery.data.league);
  }

  return { leagueQuery, league };
}
